var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.49984 13.3988C10.7215 13.3988 13.3332 10.7871 13.3332 7.56551C13.3332 4.34388 10.7215 1.73218 7.49984 1.73218C4.2782 1.73218 1.6665 4.34382 1.6665 7.56551C1.6665 10.7872 4.2782 13.3988 7.49984 13.3988ZM5.33742 6.22793C5.10957 6.00008 5.10957 5.63094 5.33742 5.40304C5.56527 5.17513 5.9344 5.17519 6.16231 5.40304L7.4999 6.74062L8.83748 5.40304C9.06533 5.17519 9.43446 5.17519 9.66237 5.40304C9.89028 5.63089 9.89022 6.00002 9.66237 6.22793L8.32479 7.56551L9.66237 8.90309C9.89022 9.13094 9.89022 9.50008 9.66237 9.72799C9.54845 9.84191 9.39917 9.8989 9.24995 9.8989C9.10074 9.8989 8.95146 9.84191 8.83754 9.72799L7.49995 8.3904L6.16237 9.72799C6.04845 9.84191 5.89917 9.8989 5.74995 9.8989C5.60074 9.8989 5.45146 9.84191 5.33754 9.72799C5.10969 9.50014 5.10969 9.131 5.33754 8.90309L6.67512 7.56551L5.33742 6.22793Z",
    fill: "#191919"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle.907ac015dcc81220c11fb0c02a0c769c.svg";
export { ForwardRef as ReactComponent };